export const routes = {
  community: {
    get: (id: string) => `/communities/${id}`,
  },
} as const;
